import React from 'react';

const Illinois = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Illinois Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Residential Real Property Disclosure Act requires a specific form.
        </li>
        <li>Radon Disclosure: Mandatory for residential transactions.</li>
        <li>
          Attorney Review Period: Standard practice, often included in
          contracts.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Illinois-Residential-Real-Property-Disclosure-Report.pdf',
                '_blank'
              );
            }}
          >
            Property Disclosure Report{' '}
          </span>{' '}
          – This form must be completed by the seller and provided to the buyer
          before signing a purchase agreement.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Illinois-Residential-Real-Property-Disclosure-Report.pdf',
                '_blank'
              );
            }}
          >
            Radon Hazards Disclosure{' '}
          </span>{' '}
          – This form must be completed by the seller to disclose any radon
          hazards.
        </li>
      </ol>
    </div>
  );
};

export default Illinois;
